export const SINGLE_INSTALLATION_NAME_OPTIONS = [
  'Flexeserve – LEFT',
  'Flexeserve – RIGHT',
  'Flexeserve – MIDDLE',
  'Flexeserve – MIDDLE LEFT',
  'Flexeserve – MIDDLE RIGHT',
  'Auxiliary',
].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

export const AIR_CONNECT_ZONE_DESCRIPTION_OPTIONS = [
  'Zone 1',
  'Zone 2',
  'Zone 3',
  'Zone 4',
  'Zone 5',
  'Smart Switch',
].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
